import { Injectable } from '@angular/core';

import { Observable, BehaviorSubject, fromEvent as observableFromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AbService {
  static readonly VARIANT_THEME_DEFAULT = 'theme-change-default';
  static readonly VARIANT_THEME_COSMIC = 'theme-change-cosmic';
  static readonly VARIANT_THEME_DARK = 'theme-change-dark';
  static readonly VARIANT_THEME_CORPORATE = 'theme-change-corporate';
  static readonly VARIANT_HIGHLIGHT_HIRE = 'highlight-hire';
  static readonly VARIANT_DEVELOPERS_HIRE = 'developers-hire';
  static readonly VARIANT_SOLUTION_HIRE = 'solution-hire';
  static readonly VARIANT_HIDE_CALL_ACTION = 'call-action-hide';
  // static readonly VARIANT_BANNER_HIRE = 'banner-hire';

  private static readonly EVENT_NAME = 'ab-variant';
  private static readonly AB_ENABLED = true;

  private events$ = new BehaviorSubject<{ name: string }>({ name: '' });

  constructor() {
    if (AbService.AB_ENABLED) {
      observableFromEvent<{ detail: { name: string } }>(document, AbService.EVENT_NAME).subscribe(
        (abEvent: { detail: { name: string } }) => {
          if (abEvent?.detail) {
            this.events$.next(abEvent.detail);
          }
        },
      );
    }
  }

  onAbEvent(name = ''): Observable<{ name: string }> {
    return this.events$.asObservable().pipe(
      filter((variant) => Boolean(variant?.name)),
      filter((variant) => (name ? variant.name === name : true)),
    );
  }
}
